import VueRouter from 'vue-router'
import Vue from 'vue';
//import Router from 'vue-router';

import Index from './pages/Index.vue';
import Documentation from './pages/Documentation.vue';
import DocumentationAPI from './pages/DocumentationAPI.vue';
import DocumentationDashboard from './pages/DocumentationDashboard.vue';
import EventExplorer from './pages/EventExplorer.vue';
import Login from './pages/Login.vue';
import Profile from './pages/Profile.vue';
import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';
import AuthComponent from './pages/components/authenticator/Authenticator.vue'
//import AuthComponent from './pages/LoginAWS.vue'
import Provider from './pages/Provider.vue'
import Privacy from './pages/Privacy.vue'
import ForgotPassword from './pages/components/ForgotPassword.vue'

//Vue.use(Router);

/*
const routes = [
  { path: '/', components: { default: Index, header: MainNavbar, footer: MainFooter }, props: {header: { colorOnScroll: 400 }, footer: { backgroundColor: 'black' }}},
  { path: '/landing', components: { default: Landing, header: MainNavbar, footer: MainFooter }, meta: { requiresAuth: true}, props: {header: { colorOnScroll: 400 }, footer: { backgroundColor: 'black' }}},
  { path: '/login', components: { default: Login, header: MainNavbar }, meta: { requiresAuth: true}, props: {header: { colorOnScroll: 400 }}},
  { path: '/profile', components: { default: Profile, header: MainNavbar, footer: MainFooter }, meta: { requiresAuth: true}, props: {header: { colorOnScroll: 400 }, footer: { backgroundColor: 'black' }}},
  { path: '/auth', components: Auth }
]
*/

const routes = [
  { path: '/', components: { default: Index, header: MainNavbar, footer: MainFooter }, props: {header: { colorOnScroll: 400 }, footer: { backgroundColor: 'black' }}},
  { path: '/documentation/api/start', params: {next: '/documentation/api/start'}, components: { default: DocumentationAPI, header: MainNavbar, footer: MainFooter }, meta: { requiresAuth: true}, props: {header: { colorOnScroll: 400 }, footer: { backgroundColor: 'black' }}},
  { path: '/documentation/dashboard/start', components: { default: DocumentationDashboard, header: MainNavbar, footer: MainFooter }, meta: { requiresAuth: true}, props: {header: { colorOnScroll: 400 }, footer: { backgroundColor: 'black' }}},
  { path: '/documentation', components: { default: Documentation, header: MainNavbar, footer: MainFooter }, props: {header: { colorOnScroll: 400 }, footer: { backgroundColor: 'black' }}},
  { path: '/explorer', components: { default: EventExplorer, header: MainNavbar, footer: MainFooter }, meta: { requiresAuth: true}, props: {header: { colorOnScroll: 400 }, footer: { backgroundColor: 'black' }}},
  { path: '/login', components: { default: Login, header: MainNavbar }, props: {header: { colorOnScroll: 400 }}},
  { path: '/provider', components: { default: Provider, header: MainNavbar, footer: MainFooter }, props: {header: { colorOnScroll: 400 }, footer: { backgroundColor: 'black' }}},
  { path: '/privacy', components: { default: Privacy, header: MainNavbar, footer: MainFooter }, props: {header: { colorOnScroll: 400 }, footer: { backgroundColor: 'black' }}},
  { path: '/auth', components: { default: AuthComponent, header: MainNavbar, footer: MainFooter  }, props: {header: { colorOnScroll: 400 }}},
  { path: '/auth/forgotpassword', components: { default: ForgotPassword, header: MainNavbar, footer: MainFooter }, props: {header: { colorOnScroll: 400 }}}

]

const router = new VueRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes,
  mode: 'history'
})

router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let user;
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(data => {

      if (data && data.signInUserSession) {
        user = data;
      }
      next()
    }).catch((e) => {
      next({
        path: '/auth',
        query: { redirect: to.fullPath }
      });
    });
  }
  next()
})



router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
            next({
                params: { nextUrl: to.fullPath },
                query: { redirect: to.fullPath }
            })

    }else {
        next()
    }
})



export default router

/*
export default new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'index',
      components: { default: Index, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/landing',
      name: 'landing',
      components: { default: Landing, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      },
      meta: { requiresAuth: true}
    },
    {
      path: '/login',
      name: 'login',
      components: { default: Login, header: MainNavbar },
      props: {
        header: { colorOnScroll: 400 }
      }
    },
    {
      path: '/profile',
      name: 'profile',
      components: { default: Profile, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
*/
